import React, { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Rating } from 'primereact/rating';
import { IEffectItemStore } from '../../../../types/effects/effectsStoreInterface';
import { useEffectUploadVideoMutation } from '../../../../services/effects/effectsStoreService';

interface EffectNoVideoTableProps {
  selectedEffects: IEffectItemStore[];
  data: IEffectItemStore[];
  setSelectedEffects: (value: IEffectItemStore[]) => void;
  reloadTable: () => void;
}
export const EffectNoVideoTable = ({
  selectedEffects,
  data,
  setSelectedEffects,
  reloadTable
}: EffectNoVideoTableProps) => {
  const [effectUploadVideo, { isSuccess }] = useEffectUploadVideoMutation();

  useEffect(() => {
    if (isSuccess) {
      reloadTable();
    }
  }, [isSuccess]);
  const renderVideoButton = (rowData: IEffectItemStore) => {
    const handleUploadVideo = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        effectUploadVideo({ effectId: rowData.id, file });
      }
    };
    return (
      <input type="file" accept="video/mp4" onChange={handleUploadVideo} />
    );
  };
  const getRating = (rowData: IEffectItemStore) => {
    return (
      <Rating
        value={rowData.rating}
        cancel={false}
        readOnly
        style={{ fontSize: '14px' }}
      />
    );
  };
  return (
    <DataTable
      scrollHeight="flex"
      selection={selectedEffects}
      selectionMode="multiple"
      metaKeySelection
      onSelectionChange={(e) => {
        setSelectedEffects(e.value);
      }}
      value={data}
      size="small"
      scrollable
      paginator={data && data.length >= 50}
      selectionPageOnly
      rows={50}
      rowsPerPageOptions={[5, 10, 25, data ? data.length : 50]}
      tableStyle={{ fontSize: '14px' }}
    >
      <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
      <Column field="name" header="Name" sortable />
      <Column field="effectType" header="Type" sortable />
      <Column field="rating" header="Rating" sortable body={getRating} />
      <Column field="" header="Upload Video" body={renderVideoButton} />
    </DataTable>
  );
};
